'use client'

import React from 'react'
import { Barcode } from 'lucide-react'
import { useBarcode } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { Badge, Indicator } from '@/components/ui'

export const BarcodeIndicator = () => {
  const { isListening, focusBarcodeInput } = useBarcode()

  return (
    <div
      className={cn('hidden cursor-pointer items-center gap-1.5 lg:flex')}
      onClick={focusBarcodeInput}
    >
      <Badge
        size="lg"
        className="h-7"
        variant={isListening ? 'green-outline' : 'secondary'}
      >
        <Barcode size={16} />
      </Badge>
    </div>
  )
}

BarcodeIndicator.displayName = 'BarcodeIndicator'
